import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import AvatarPopover from '../AvatarPopover';
import DateTime from '../DateTime';
import { getSetting } from '../../helpers/Settings';

const FileDateUser = ({
  id,
  user,
  date,
  title,
  file,
}) => {
  const intl = useIntl();

  const getUploadPageUploadedByText = () => {
    let text = '';

    if (file.attributes?.upload_page_access_name) {
      text += `${file.attributes?.upload_page_access_name}`;
    }

    if (text.length > 0 && file.attributes?.upload_page_access_email) {
      text += ' ';
    }

    if (file.attributes?.upload_page_access_email) {
      text += `(${file.attributes?.upload_page_access_email})`;
    }

    if (text.length === 0) {
      text += intl.formatMessage({ defaultMessage: 'Someone' });
    }

    text += ' ';
    text += intl.formatMessage({ defaultMessage: 'via Guest Upload:' });

    return text;
  };

  return (
    <>
      {`${title} `}
      <DateTime
        id={`file-uploaded-${id}`}
        className="file-uploaded"
        dateTime={date}
      />
      {user && (
        <span className="file-uploaded-by">
          {' '}{intl.formatMessage({ defaultMessage: 'by' })}{' '}
          {(file && file.attributes?.upload_page_uuid) && (
          <>
            {getUploadPageUploadedByText()}
            {' '}
            <a href={`${getSetting('workspace_url')}/u/${file.attributes?.upload_page_url}`}>
              {file.attributes?.upload_page_title}
            </a>
          </>
          )}
          {(!file || !file.attributes?.upload_page_uuid) && (
            <span id={`file-uploaded-by-${user.uuid}`} className={user.deactivated_at ? 'inactive' : ''}>
              {user.deactivated_at && (
                <i className="fas fa-ban" />
              )}
              <a id={`file-user-name-${id}`} href="#profile" onClick={(e) => { e.preventDefault(); }}>
                {user.name}
              </a>
              <AvatarPopover
                user={user}
                targetId={`file-user-name-${id}`}
              />
            </span>
          )}
        </span>
      )}
      {((!file || !file.attributes?.upload_page_uuid) && user && user.deactivated_at) && (
        <UncontrolledTooltip placement="bottom" target={`file-uploaded-by-${user.uuid}`}>
          {intl.formatMessage({ defaultMessage: 'This account is inactive' })}
        </UncontrolledTooltip>
      )}
    </>
  );
};

FileDateUser.propTypes = {
  file: PropTypes.object,
  id: PropTypes.string.isRequired,
  user: PropTypes.object,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

FileDateUser.defaultProps = {
  file: null,
  user: null,
};

export default FileDateUser;
